import React from 'react';

// The twelve Impact AS Plus™ instruments, grouped. Each links to /product/[slug]
// which embeds the corresponding impactasportal.com product page.
const peopleInstruments = [
  { name: 'DISC Lens\u2122', slug: 'disc-lens', desc: 'How a person works, read together with what they value and what drives them' },
  { name: 'DISC Lens Africa\u2122', slug: 'disc-africa', desc: 'DISC Lens\u2122 built for African workplaces' },
  { name: 'EI Lens\u2122', slug: 'ei-lens', desc: "How a leader handles emotion, their own and other people's" },
  { name: 'PurposeMap\u2122', slug: 'purposemap', desc: 'What drives a leader, and where they want to go next' },
  { name: 'InsightEdge\u2122', slug: 'insightedge', desc: 'How a person thinks through complex decisions' },
  { name: 'Impact 360\u2122', slug: 'impact-360', desc: 'See how a leader is experienced by the people around them' },
  { name: 'Leadership Mirror\u2122', slug: 'leadership-mirror', desc: 'The leadership a person intends, set against the leadership people experience' },
  { name: 'Executive Mirror\u2122', slug: 'executive-mirror', desc: 'How an executive shapes the organisation around them' },
  { name: 'JobFit\u2122', slug: 'jobfit', desc: 'Hiring decisions you can explain and defend' },
];

const teamInstruments = [
  { name: 'DISC Lens Teams\u2122', slug: 'disc-africa-teams', desc: "How a team's styles combine" },
  { name: 'TeamEdge\u2122', slug: 'team-edge', desc: 'Where a team is strong, and where it is stuck' },
  { name: 'CulturePulse\u2122', slug: 'culture-pulse', desc: 'How people actually experience your organisation' },
];

const InstrumentCard = ({ item }) => (
  <a
    href={`/product/${item.slug}`}
    className="block bg-white rounded-xl p-5 border border-slate-200 hover:border-[#2693d0] hover:shadow-md transition-all duration-300 group focus:outline-none focus:ring-2 focus:ring-[#2693d0] focus:ring-offset-2"
    data-testid={`instrument-${item.slug}`}
  >
    <h4 className="text-slate-800 font-semibold text-base mb-1.5 group-hover:text-[#2693d0] transition-colors">{item.name}</h4>
    <p className="text-slate-600 text-sm leading-relaxed">{item.desc}</p>
  </a>
);

export const DiagnosticsInstruments = ({ className = '' }) => {
  return (
    <div className={className} data-testid="diagnostics-instruments">
      {/* People */}
      <div className="mb-10">
        <h3 className="text-slate-500 text-xs font-semibold uppercase tracking-wider mb-4">People</h3>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {peopleInstruments.map((item) => (
            <InstrumentCard key={item.slug} item={item} />
          ))}
        </div>
      </div>

      {/* Teams and organisations */}
      <div>
        <h3 className="text-slate-500 text-xs font-semibold uppercase tracking-wider mb-4">Teams and organisations</h3>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {teamInstruments.map((item) => (
            <InstrumentCard key={item.slug} item={item} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default DiagnosticsInstruments;
